module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: false
      }
    }
  }, [_vm._v("今天表现")]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "待完成作业, 课堂表现"
    }
  }, _vm._l((_vm.courseInstances), function(courseInstance) {
    return _c('cell', {
      key: courseInstance.id,
      attrs: {
        "title": courseInstance.course.name,
        "inline-desc": courseInstance.teacher.name,
        "link": ("/course/" + (courseInstance.id))
      }
    }, [_c('badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (courseInstance.comments),
        expression: "courseInstance.comments"
      }]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(courseInstance.homework === 0 ? '-' : courseInstance.homework))]), _vm._v(" "), _c('span', {
      staticClass: "vertical-middle"
    }, [_vm._v("  " + _vm._s(courseInstance.participation) + "  ")])], 1)
  }))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf82b76c"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Day.vue
// module id = 574
// module chunks = 1